import React from 'react';
import './TnC.css'
const Tnc = () => {
    return ( 
        <div className='tnc-cntnr' >
            <p>Review the below terms & conditions carefully: </p>
            <p className='tnc-text' ><span className='tnc-number' >1. </span>This scheme is valid only on ULIP policies, offered by Axis Max Life Insurance, that are due and unpaid. Decision of Axis Max Life on revival shall be final.</p>
            <p className='tnc-text' ><span className='tnc-number' >2. </span>Even if the fund growth is enough to reinstate the policy, Policyholder shall be required to pay at least 25% of the due premium, else the policy will not be reinstated.</p>
            <p className='tnc-text' ><span className='tnc-number' >3. </span>This revival scheme will be applicable only once during the first five policy years from the date of commencement of risk under the policy and during the revival period.</p>
            <p className='tnc-text' ><span className='tnc-number' >4. </span>Fund value as on the date of revival shall be taken into consideration and not on the date of applying for the scheme.</p>
        </div>
     );
}
 
export default Tnc;